import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import strings from 'utils/strings'
import { isEmpty, prop, values, compose, keys, length, inc } from 'ramda'
import {
  getDashListsDefinitions,
  getIsPreProduction,
  getUnassignedComponents,
} from 'selectors/dash'
import { useMakeSelector, useSelector } from 'hooks/redux'
import { HoverableInfoIcon } from 'components/patterns'
import { DropLocation } from 'components/DragAndDrop'
import {
  DraggableUnassignedPartList,
  ListHeaderAndIcon,
  DragIcon,
  ListHeader,
  UnAssignedPartHeaderIcon,
  UnAssignedPartHeader,
} from 'components/SwitchAndGauge/DashDrawer/DraggableList/DraggablePartListView.style'
import DraggablePart from 'components/SwitchAndGauge/DashDrawer/DraggableList/DraggablePart'
import DashPanelSection from 'components/SwitchAndGauge/DashDrawer/DraggableList/DashPanelSection'
import PreProdUnassignedComponents from 'components/SwitchAndGauge/DashDrawer/DraggableList/PreProdUnassignedComponents'
import setTheme from 'theme'
import { DASH_VIEW } from 'utils/constants'
import { makeComponentMetaSelector } from 'selectors/navigator'

const CollectionOfSections = () => {
  const { id: listId } = useMakeSelector(makeComponentMetaSelector, {
    id: DASH_VIEW,
  })

  const listDefinitions = useSelector(getDashListsDefinitions, {
    id: listId,
  })

  return (
    <>
      {listDefinitions.map((definition) => (
        <DashPanelSection
          key={prop('id', definition)}
          definition={definition}
        />
      ))}
    </>
  )
}

const DraggablePartListView = () => {
  const isPreProdVehicle = useSelector(getIsPreProduction)

  return (
    <>
      {isPreProdVehicle ? (
        <PreProdUnassignedComponents />
      ) : (
        <UnassignedComponents />
      )}
      <CollectionOfSections />
    </>
  )
}

DraggablePartListView.propTypes = {
  data: PropTypes.object,
  definitions: PropTypes.array,
  showPartDetails: PropTypes.func,
}

export default DraggablePartListView

const UnassignedComponents = () => {
  const themes = setTheme()
  const unassignedComponents = useSelector(getUnassignedComponents)
  const list = useMemo(
    () =>
      values(unassignedComponents).map((component, index) => {
        const location = prop('location', component)
        return (
          <DropLocation key={location} location={location}>
            <DraggablePart location={location} index={inc(index)} />
          </DropLocation>
        )
      }),
    [unassignedComponents]
  )

  if (isEmpty(unassignedComponents)) {
    return null
  }

  return (
    <DraggableUnassignedPartList>
      <>
        <UnAssignedPartHeaderIcon
          icon="alert_exclamation_triangle_solid"
          fill={themes.badgeWarningColor}
        />
        <UnAssignedPartHeader>
          {strings.parts_without_locations}
        </UnAssignedPartHeader>
      </>
      {list}
    </DraggableUnassignedPartList>
  )
}

const ListSectionHeader = ({ definition }) => {
  const groupLength = compose(length, keys, prop('groups'))(definition)

  const label = prop('label', definition)
  const showHelp = Boolean(groupLength)

  return (
    <ListHeaderAndIcon groupLength={groupLength}>
      <ListHeader key={prop('label', definition)}>{label}</ListHeader>
      {showHelp && (
        <DragIcon>
          <HoverableInfoIcon tooltip={strings.drag_part_to_desired_location} />
        </DragIcon>
      )}
    </ListHeaderAndIcon>
  )
}

ListSectionHeader.propTypes = {
  definition: PropTypes.object,
}
